import React from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const ProgressBar = ({ value, max = 100, barColor = "#22BE39" }) => {
  const width = (value / max) * 100;

  return (
    <Box display="flex" alignItems="center" gap="8px" width="100%">
      <div
        className="w-full"
        style={{
          height: "12px",
          backgroundColor: "#5B6D7A20",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            height: "12px",
            width: `${width}%`,
            backgroundColor: barColor,
            borderRadius: "20px",
          }}
        ></div>
      </div>
      <Typography minWidth="40px" textAlign="right" fontSize="16px">
        {value ?? 0}%
      </Typography>
    </Box>
  );
};

export default ProgressBar;
